import { useEffect, useState } from "react";
import { useInvoiceContext } from "../../../utils/invoiceContext";
import './accounting.css';

function Accounting() {
    const { invoices, fetchInvoices } = useInvoiceContext();
    const [unpaidInvoices, setUnpaidInvoices] = useState([]);

    useEffect(() => {
        fetchInvoices();
        const unpaid = (invoices || []).filter(inv => !inv.isPaid);
        setUnpaidInvoices(unpaid);
    }, [invoices]);


    const invoiceTotals = invoices.map(inv =>
        inv.items.reduce((sum, item) => sum + (Number(item.totalBrut) || 0), 0)
    );

    const unpaidInvoiceTotals = unpaidInvoices.map(inv =>
        inv.items.reduce((sum, item) => sum + (Number(item.totalBrut) || 0), 0)
    );

    const totalRevenue = invoiceTotals.reduce((sum, val) => sum + val, 0);
    const totalUnpaidRevenue = unpaidInvoiceTotals.reduce((sum, val) => sum + val, 0);

    return (
        <div className='pageContainer'>
            <h1 className="accountingHeading">Buchhaltung</h1>

            <div className="accountingContainer">
                {/* Einnahmen */}
                <div className="incomeContainer">
                    <h2 className="incomeHeading">Einnahmen</h2>
                    <p className="incomePaidTotal">
                        Gesamt: {totalRevenue.toFixed(2)} €
                    </p>
                    <div>
                        {invoices.map((inv, idx) => (
                            <div key={inv._id || idx}>
                                <b>Rechnung {inv.invoiceNumber || inv._id}:</b> {invoiceTotals[idx].toFixed(2)} €
                            </div>
                        ))}
                    </div>
                    <p className="incomeUnpaidTotal">
                        Ausstehend: {totalUnpaidRevenue.toFixed(2)} €
                    </p>
                    <div>
                        {unpaidInvoices.map((inv, idx) => (
                            <div key={inv._id || idx}>
                                <b>Rechnung {inv.invoiceNumber || inv._id}:</b> {unpaidInvoiceTotals[idx].toFixed(2)} €
                            </div>
                        ))}
                    </div>
                </div>

                {/* Ausgaben */}
                <div className="expensesContainer">
                    <h2 className="expensesHeading">Ausgaben</h2>
                    <p className="expensesTotal">–</p>
                </div>
            </div>
        </div>
    );
}

export default Accounting;